(function () {
  'use strict';
  if (window.CroSightLocalization) return;
  var contextElement = document.getElementById('crosight-localization-context');
  if (!contextElement) return;
  var context;
  try { context = JSON.parse(contextElement.textContent); } catch (error) { return; }
  var embedded = context.designMode || window.top !== window.self;
  var prefix = 'crosight-localization-v3:' + context.themeId + ':';
  var sourceSelector = '[id^="etranslate-language_currency-"][id*="-selector-theme"]';
  var submitting = false;
  var interacted = false;
  var syncQueued = false;
  var convertedRoots = new WeakMap();
  var originalAutoCurrency = false;
  var pluginConfig = null;

  function read(storage, key) {
    try { return window[storage].getItem(key); } catch (error) { return null; }
  }
  function write(storage, key, value) {
    try { window[storage].setItem(key, value); } catch (error) {}
  }
  function remove(storage, key) {
    try { window[storage].removeItem(key); } catch (error) {}
  }
  function readObject(storage, key) {
    try { return JSON.parse(read(storage, key) || 'null'); } catch (error) { return null; }
  }
  function validCountry(code) {
    return context.countries.some(function (item) { return item.code === code; });
  }
  function validLanguage(code) {
    return context.languages.find(function (language) {
      return language.toLowerCase() === String(code || '').toLowerCase();
    });
  }
  function currentCurrency() {
    var requested = context.country === 'CA' ? 'CAD' : context.country === 'US' ? 'USD' : context.currency;
    return pluginConfig && Number(pluginConfig.status) === 1 && pluginConfig.user_currencies_data.some(function (item) {
      return item.code === requested;
    }) ? requested : context.currency;
  }

  // This classic defer script precedes Langwill's classic defer script in the head.
  // Keep the app's translations/rates/widgets; let this controller own localization.
  function configurePlugin() {
    var source = document.getElementById('shop_metaFields_v2');
    if (!source) return;
    try {
      var config = JSON.parse(source.textContent);
      var settings = typeof config.global === 'string' ? JSON.parse(config.global) : config.global;
      if (!settings || !Array.isArray(config.user_currencies_data)) return;
      originalAutoCurrency = Number(config.status) === 1 && Number(settings.auto_switch_location_currency) === 1;
      settings.auto_switch_location_currency = 0;
      settings.auto_switch_location_language = 0;
      settings.auto_switch_location_language_ip = 0;
      config.global = typeof config.global === 'string' ? JSON.stringify(settings) : settings;
      source.textContent = JSON.stringify(config);
      pluginConfig = config;
      // Converter state is derived from the server market, never treated as a visitor preference.
      write('localStorage', 'currentCurrency', currentCurrency());
    } catch (error) {}
  }

  function commitConfirmedChoice() {
    var pending = readObject('sessionStorage', prefix + 'pending');
    if (!pending || Date.now() - pending.at > 120000) {
      remove('sessionStorage', prefix + 'pending');
      return;
    }
    if (pending.country !== context.country || pending.language !== context.language) return;
    if (!embedded) {
      if (pending.manualCountry) write('localStorage', prefix + 'country', context.country);
      if (pending.manualLanguage) {
        write('localStorage', prefix + 'language', context.language);
        write('localStorage', 'lan_code', context.language);
      }
      write('sessionStorage', prefix + 'checked', '1');
    }
    remove('sessionStorage', prefix + 'pending');
  }

  function destination(language, country) {
    var url = new URL(window.location.href);
    ['country', 'currency', 'locale', 'language'].forEach(function (key) { url.searchParams.delete(key); });
    var parts = url.pathname.split('/');
    if (validLanguage(parts[1])) parts.splice(1, 1);
    if (language !== 'en') parts.splice(1, 0, language);
    url.pathname = parts.join('/') || '/';
    if (embedded) url.searchParams.set('country', country);
    return url.pathname + url.search + url.hash;
  }

  function setBusy(busy) {
    document.querySelectorAll('[data-crosight-market-menu] [role="listbox"]').forEach(function (list) {
      list.setAttribute('aria-busy', String(busy));
    });
  }
  function submitLocalization(country, language, manualCountry, manualLanguage, automatic) {
    if (submitting || !validCountry(country) || !validLanguage(language)) return;
    if (country === context.country && language === context.language) {
      if (!embedded && manualCountry) write('localStorage', prefix + 'country', country);
      if (!embedded && manualLanguage) {
        write('localStorage', prefix + 'language', language);
        write('localStorage', 'lan_code', language);
      }
      return;
    }
    submitting = true;
    setBusy(true);
    var pending = { country: country, language: language, manualCountry: manualCountry, manualLanguage: manualLanguage, at: Date.now() };
    write('sessionStorage', prefix + 'pending', JSON.stringify(pending));
    var path = destination(language, country);
    if (!embedded && !read('sessionStorage', prefix + 'pending')) {
      var fallback = new URL(path, window.location.origin);
      fallback.searchParams.set('country', country);
      if (automatic) fallback.searchParams.set('_crosight_localized', '1');
      path = fallback.pathname + fallback.search + fallback.hash;
    }
    if (embedded) {
      // Reload this preview in the requested country; do not manipulate the admin parent.
      window.location.assign(path);
    } else {
      var form = document.createElement('form');
      form.method = 'POST';
      form.action = '/localization';
      form.hidden = true;
      var fields = { form_type: 'localization', utf8: '\u2713', _method: 'put', country_code: country, language_code: language, return_to: path };
      Object.keys(fields).forEach(function (name) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = fields[name];
        form.appendChild(input);
      });
      document.body.appendChild(form);
      HTMLFormElement.prototype.submit.call(form);
    }
    window.setTimeout(function () {
      submitting = false;
      setBusy(false);
    }, 10000);
  }

  function handleManualSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('.crosight-market-form, form[id^="localization-form-"]')) return;
    var button = event.submitter;
    if (!button || !['country_code', 'locale_code', 'language_code'].includes(button.name)) return;
    interacted = true;
    event.preventDefault();
    event.stopImmediatePropagation();
    var countryChange = button.name === 'country_code';
    submitLocalization(countryChange ? button.value : context.country,
      countryChange ? context.language : validLanguage(button.value), countryChange, !countryChange);
  }

  function explicitLanguage() {
    return validLanguage(window.location.pathname.split('/')[1]);
  }
  function browserLanguage(country) {
    var allowed = country === 'US' ? ['en', 'es'] : country === 'CA' ? ['en', 'fr'] : context.languages;
    var preferences = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || 'en'];
    for (var i = 0; i < preferences.length; i++) {
      var code = String(preferences[i]).toLowerCase().split('-')[0];
      if (allowed.includes(code) && validLanguage(code)) return validLanguage(code);
    }
    return validLanguage('en') || context.language;
  }
  async function localizeFirstVisit() {
    if (embedded || !pluginConfig || Number(pluginConfig.status) !== 1 || read('sessionStorage', prefix + 'checked')) return;
    // A bounded attempt prevents loops if a browser blocks localization or storage.
    var guard = new URL(window.location.href).searchParams.get('_crosight_localized');
    if (guard) return;
    var storedCountry = read('localStorage', prefix + 'country');
    var requestedCountry = new URL(window.location.href).searchParams.get('country');
    var country = validCountry(requestedCountry) ? requestedCountry : validCountry(storedCountry) ? storedCountry : originalAutoCurrency ? null : context.country;
    var storedLanguage = validLanguage(read('localStorage', prefix + 'language'));
    var language = explicitLanguage() || storedLanguage;
    if (!country) {
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 4000);
      try {
        var root = (context.root || '/').replace(/\/?$/, '/');
        var response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {
          credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;
        var result = await response.json();
        var detected = result.detected_values && result.detected_values.country && result.detected_values.country.handle;
        country = validCountry(detected) ? detected : context.country;
      } catch (error) { return; }
      finally { window.clearTimeout(timeout); }
    }
    if (interacted || submitting) return;
    language = language || browserLanguage(country);
    write('sessionStorage', prefix + 'checked', '1');
    submitLocalization(country, language, false, false, true);
  }

  function syncEmbeddedCurrency(root, currency) {
    if (!embedded || convertedRoots.get(root) === currency) return;
    var options = Array.from(root.querySelectorAll('.etranslate-currency-dropdown .etranslate-selector-dropdown-item'));
    var target = options.find(function (option) { return option.dataset.code === currency && typeof option.onclick === 'function'; });
    var base = options.find(function (option) { return option.dataset.code === context.currency && typeof option.onclick === 'function'; });
    var apply = root.querySelector('.etranslate-change-button');
    if (!target || !base || !apply) return;
    convertedRoots.set(root, currency);
    // Langwill skips initial conversion inside an iframe. Its Apply path is display-only there.
    if (currency !== context.currency) { base.click(); apply.click(); }
    target.click();
    apply.click();
  }
  function syncDisplay() {
    syncQueued = false;
    var currency = currentCurrency();
    var conversionReady = currency === context.currency || document.querySelector('.langwill-money[data-currency="' + currency + '"]');
    var displayCurrency = conversionReady ? currency : context.currency;
    document.documentElement.dataset.crosightCurrencyCode = displayCurrency;
    document.querySelectorAll('[data-crosight-price-currency]').forEach(function (label) {
      var price = label.parentElement.querySelector('.langwill-money');
      var code = price && currency !== context.currency && price.dataset.currency !== currency ? context.currency : displayCurrency;
      if (label.textContent !== code) label.textContent = code;
    });
    document.querySelectorAll(sourceSelector).forEach(function (root) {
      if (root.getAttribute('aria-hidden') !== 'true') root.setAttribute('aria-hidden', 'true');
      root.querySelectorAll('button, a[href], input:not([type="hidden"]), select, [tabindex]').forEach(function (control) {
        if (control.getAttribute('tabindex') !== '-1') control.setAttribute('tabindex', '-1');
      });
      syncEmbeddedCurrency(root, currency);
    });
  }
  function scheduleSync() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(syncDisplay);
  }

  configurePlugin();
  commitConfirmedChoice();
  document.addEventListener('submit', handleManualSubmit, true);
  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('currency:refresh', scheduleSync);
  window.addEventListener('pageshow', function () { submitting = false; setBusy(false); scheduleSync(); });
  var observer = new MutationObserver(function (records) {
    if (records.some(function (record) {
      if (record.type === 'attributes') return record.target.matches('.langwill-money');
      var sourceRoot = record.target.nodeType === 1 && record.target.closest(sourceSelector);
      if (sourceRoot) {
        if (Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('.etranslate-selector-dropdown-item, .etranslate-currency-dropdown') || node.querySelector('.etranslate-selector-dropdown-item'));
        })) convertedRoots.delete(sourceRoot);
        return true;
      }
      return Array.from(record.addedNodes).some(function (node) {
        return node.nodeType === 1 && (node.matches(sourceSelector + ', [data-crosight-price-currency]') ||
          node.querySelector(sourceSelector + ', [data-crosight-price-currency]'));
      });
    })) scheduleSync();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-currency'] });
  var retries = 0;
  var readyTimer = window.setInterval(function () { scheduleSync(); if (++retries >= 30) window.clearInterval(readyTimer); }, 250);
  window.CroSightLocalization = { country: context.country, language: context.language, mode: 'shopify-market-with-langwill' };
  window.CroSightCurrencyDisplay = { apply: scheduleSync, mode: 'shopify-market-with-langwill' };
  scheduleSync();
  localizeFirstVisit();
})();
